import { render, staticRenderFns } from "./ResourceCategory.vue?vue&type=template&id=8630ff8c&"
import script from "./ResourceCategory.vue?vue&type=script&lang=js&"
export * from "./ResourceCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports